import { type IconProps, iconVariants } from '@/components/icons/common'

export function TerminalIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      role="presentation"
      className={iconVariants({ size, className })}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 9.20435 2 7.80653 2.45672 6.7039C3.06569 5.23373 4.23373 4.06569 5.7039 3.45672C6.80653 3 8.20435 3 11 3H13C15.7956 3 17.1935 3 18.2961 3.45672C19.7663 4.06569 20.9343 5.23373 21.5433 6.7039C22 7.80653 22 9.20435 22 12C22 14.7956 22 16.1935 21.5433 17.2961C20.9343 18.7663 19.7663 19.9343 18.2961 20.5433C17.1935 21 15.7956 21 13 21H11C8.20435 21 6.80653 21 5.7039 20.5433C4.23373 19.9343 3.06569 18.7663 2.45672 17.2961C2 16.1935 2 14.7956 2 12ZM6.364 9.6025C6.14447 9.95375 6.25125 10.4165 6.6025 10.636L9.2457 12.288C9.40237 12.3859 9.40237 12.6141 9.2457 12.712L6.6025 14.364C6.25125 14.5835 6.14447 15.0462 6.364 15.3975C6.58353 15.7488 7.04625 15.8555 7.3975 15.636L10.0407 13.984C11.1374 13.2986 11.1374 11.7014 10.0407 11.016L7.3975 9.364C7.04625 9.14447 6.58353 9.25125 6.364 9.6025ZM13 14.25C12.5858 14.25 12.25 14.5858 12.25 15C12.25 15.4142 12.5858 15.75 13 15.75H17C17.4142 15.75 17.75 15.4142 17.75 15C17.75 14.5858 17.4142 14.25 17 14.25H13Z"
        fill="currentColor"
      />
    </svg>
  )
}
